import { useEffect } from 'react';
import { useApiCall, type ApiCallState } from './useApi.js';

/**
 * useApiPolled · 在 useApiCall 上加定时轮询。
 *
 * shouldPoll 控制开关（false 时只在依赖变化时拉一次）。
 * 用法：列表里有 processing 行就开轮询，全 done 后就关。
 */
export function useApiPolled<T>(
  fn: () => Promise<T>,
  intervalMs: number,
  deps: ReadonlyArray<unknown>,
  shouldPoll: boolean,
): ApiCallState<T> {
  const result = useApiCall(fn, deps);
  const { refresh, loading } = result;

  useEffect(() => {
    if (!shouldPoll) return;
    const id = window.setInterval(() => {
      // 不踩正在飞着的请求
      if (!loading) refresh();
    }, intervalMs);
    return () => window.clearInterval(id);
  // refresh 是稳定的（useCallback in useApi）；loading 变化不需要重建 interval
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldPoll, intervalMs, refresh]);

  return result;
}
